import { FC } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';

import { CloseButton, MDBox, MDButton, MDTypography } from '@components/index';
import { sendAmplitudeData } from '@utils/amplitude';
import { EMPTIED_TRASH } from '@constants/eventNames';

interface Props {
  open: boolean;
  projectName?: string;
  onClose: () => void;
  onProceedButtonClick: () => void;
  title?: string;
  subtitle?: string;
  proceedButtonMessage?: string;
  cancelButtonText?: string;
  showSubTitle?: boolean;
  isEmptyTrash?: boolean;
}

const ConfirmationModal: FC<Props> = ({
  open,
  projectName = '',
  onClose,
  onProceedButtonClick,
  title,
  subtitle,
  proceedButtonMessage,
  showSubTitle = true,
  cancelButtonText = 'NO, GO BACK!',
  isEmptyTrash = false
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    sx={{
      zIndex: 9999,
      '& .MuiPaper-root': {
        width: '540px',
        maxWidth: '800px',
        position: 'relative',
        overflow: 'visible'
      }
    }}
  >
    <CloseButton onClose={() => onClose()} />
    <DialogTitle sx={{ my: 2 }} {...({ component: 'div' } as any)}>
      <MDTypography
        variant='h3'
        color='secondary'
        textGradient
        sx={{ whiteSpace: 'wrap' }}
      >
        {title}
      </MDTypography>
    </DialogTitle>
    {showSubTitle && (
      <DialogContent>
        <MDTypography
          variant='h5'
          color='info'
          sx={{ overflowWrap: 'anywhere' }}
        >
          {subtitle} {projectName}
        </MDTypography>
      </DialogContent>
    )}

    <DialogActions
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mb: 3,
        alignItems: 'flex-start'
      }}
    >
      <MDBox
        display='flex'
        flexDirection='column'
        alignItems='center'
        mr={1}
        rowGap={1}
      >
        <MDButton color='secondary' variant='outlined' onClick={onClose}>
          {cancelButtonText}
        </MDButton>
      </MDBox>
      <MDButton
        color='primary'
        variant='gradient'
        onClick={() => {
          onProceedButtonClick();
          if (isEmptyTrash) sendAmplitudeData(EMPTIED_TRASH);
        }}
      >
        {proceedButtonMessage}
      </MDButton>
    </DialogActions>
  </Dialog>
);

export default ConfirmationModal;
